import { EntityMode } from '../enum/entity-mode.enum';
import { PermissionKey } from '../enum/permission-key.enum';

// Each permission as the person sees it, never its key, so a refusal says what is missing.
export const PERMISSION_NAMES: Record<PermissionKey, string> = {
    [PermissionKey.PLAYBOOKS]: 'Playbooks',
    [PermissionKey.RUNS]: 'Runs',
    [PermissionKey.CONTACTS]: 'Contacts',
    [PermissionKey.KNOWLEDGE_BASES]: 'Knowledge bases',
    [PermissionKey.SETTINGS_WHATSAPP]: 'WhatsApp settings',
    [PermissionKey.SETTINGS_TEMPLATES]: 'Templates',
    [PermissionKey.SETTINGS_SENDING]: 'Sending settings',
    [PermissionKey.SETTINGS_STORES]: 'Store connections',
    [PermissionKey.SETTINGS_AI_KEYS]: 'AI keys',
    [PermissionKey.STAFF_AND_ROLES]: 'Staff and roles',
    [PermissionKey.PLATFORM_BUSINESS_ACCESS]: 'Business access',
    [PermissionKey.PLATFORM_PLAYBOOKS]: 'Global playbooks',
};

// What a refusal says the person may not do, by what they tried.
export const REFUSAL_VERBS: Record<EntityMode, string> = {
    [EntityMode.CREATE]: 'adding',
    [EntityMode.EDIT]: 'editing',
    [EntityMode.VIEW]: 'viewing',
};

// The address segments of a page that creates or edits; opening one needs `manage`.
export const WRITING_SEGMENTS = [EntityMode.CREATE, EntityMode.EDIT];
